module.exports = __webpack_public_path__ + "static/media/DWFuturaLatinExtB.106225cb.woff2";